import React from 'react';

const ActionButton = ({ onClick }) => {
    return (
        <button
            onClick={onClick}
            className={`group relative inline-flex h-10 items-center justify-center overflow-hidden rounded-md bg-main-blue text-main-white px-6 font-medium transition hover:bg-main-blue/80 hover:scale-105`}
        >
            <span>Action</span>
            <div className="absolute inset-0 flex h-full w-full justify-center [transform:skew(-12deg)_translateX(-100%)] group-hover:duration-1000 group-hover:[transform:skew(-12deg)_translateX(100%)]">
                <div className="relative h-full w-8 bg-main-blue/30"></div>
            </div>
        </button>
    );
};

export default ActionButton;
